// Base address of the module icon images (the `icons/` folder in Firebase Storage).
//
// Built from the CURRENT environment's own storage bucket (REACT_APP_FIREBASE_STORAGE_BUCKET, set per
// Vercel project), so development, staging and production each load their icons from their own bucket
// instead of all depending on the development project's storage.
//
// Each environment's bucket must contain the six icon files with the same download tokens used in the
// URLs that append to this base (they are preserved when files are copied between projects).
const BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;

export const ICON_BASE_URL = `https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o/icons%2F`;
